import React, { useEffect, useState } from 'react'
import { connect, useDispatch } from 'react-redux'
import { RootState } from 'Store'
import { Checkbox, Col, Image, Input, Row, Space, Switch } from 'antd'
import { PrimaryButton } from 'Components/button'
import { Data, ListReq, ProductOptions } from 'Store/product/types'
import { productListAPI } from 'Store/product/api'
import { selectList, selectListEvent } from 'Store/product/selector'
import { selectCurrentUser } from 'Store/user/selector'
import { LabelItem, SelectItem } from 'Components/form'
import { DetailDrawer } from 'Components/common/MainLayout'
import { TableListPage } from 'Components/common/Table'
import { Pagination } from 'Components/Pagination'
import styled from 'styled-components'
import { appConfig } from 'config'
import { SearchOutlined } from '@ant-design/icons'
import { MyTheme } from 'Components/common/Theme'
import { getMenuSelect } from 'helpers/format'
import { ImageFallback } from 'helpers/constanst'
import { merchantDropdownAPI } from 'Store/merchants/api'
import { cloneDeep } from 'lodash'
import Category from 'Components/form/Category'
import { categoriesListAPI } from 'Store/categories/api'
import { manufactuerListAPI } from 'Store/manufactuer/api'
import { selectList as selectCateList } from 'Store/categories/selector'
import { selectList as selectManufactuerList } from 'Store/manufactuer/selector'
import { selectDatas } from 'Store/config/selector'
import { PointProductConfig } from 'Store/member-point/types'

type Props = ReduxProps & {
  visible: boolean
  onCloseDrawer: () => void
  onSaveProduct?: (products: PointProductConfig[]) => void
  products: PointProductConfig[]
  disableProduct: PointProductConfig[]
}

const ProductsDrawer: React.FunctionComponent<Props> = props => {
  const {
    onCloseDrawer,
    visible,
    currentUser,
    event,
    onSaveProduct = () => {},
    dataList,
    products,
    categories,
    manufactuers,
    disableProduct,
  } = props

  const initFilter = {
    keyword: '',
    merchant_id: 0,
    selectedOnly: false,
    categories: [] as number[],
    manufactuers: 0,
  }

  const datas = dataList.data
  const meta = dataList.meta

  const [pagination, setPagination] = useState({
    Page: 1,
    RowPerPage: 20,
  })
  const [filter, setFilter] = useState(cloneDeep(initFilter))
  const [selectProduct, setSelectProduct] = useState([] as PointProductConfig[])
  const [searchKeyword, setSearchKeyword] = useState('')
  const dispatch = useDispatch()

  const title = 'เลือกรายการสินค้า'

  useEffect(() => {
    if (visible) {
      getMerchantDropdownData()
      onGetMasterData()
    }
    return () => {
      setSelectProduct([])
      setFilter(cloneDeep(initFilter))
      pagination.Page = 1
      pagination.RowPerPage = 20
      setPagination({ ...pagination })
    }
  }, [visible])

  useEffect(() => {
    if (visible) {
      setSelectProduct(products)
    }
  }, [products, visible])

  useEffect(() => {
    if (currentUser?.accessToken && visible) {
      onGetProducts()
    }
  }, [pagination])

  const getSelectedProductID = () => {
    const productIds = [] as number[]
    selectProduct &&
      selectProduct.forEach(item => {
        if (!productIds?.includes(item.product_id)) {
          productIds.push(item.product_id)
        }
      })
    return productIds
  }

  const onGetProducts = (): void => {
    const req: ListReq = {
      merchant_id: currentUser?.activeMerchant?.id || 0,
      page: pagination.Page,
      per_page: pagination.RowPerPage,
      keyword: filter.keyword?.trim() || '',
      group_id: (filter?.categories && filter?.categories[0]) || 0,
      is_admin: true,
      manufacturer_id: filter?.manufactuers || 0,
      ids: filter.selectedOnly ? getSelectedProductID() : [],
    }

    if (filter?.categories && filter?.categories[1]) {
      req.category_id = filter?.categories[1]
    }
    if (filter?.categories && filter?.categories[2]) {
      req.sub_category_id = filter?.categories[2]
    }
    dispatch(productListAPI(req, currentUser.accessToken))
  }

  const getMerchantDropdownData = (): void => {
    dispatch(merchantDropdownAPI({}, currentUser.accessToken))
  }

  const onGetMasterData = (): void => {
    const merchant_id = currentUser?.activeMerchant?.id || 0
    const token = currentUser.accessToken
    dispatch(
      categoriesListAPI(
        {
          merchant_id,
          include_child: true,
        },
        token,
      ),
    )
    dispatch(
      manufactuerListAPI(
        {
          merchant_id,
        },
        token,
      ),
    )
  }

  const onFilter = (key: string, val: any) => {
    setFilter({
      ...filter,
      [key]: val,
    })
  }

  const onClickSearch = (): void => {
    pagination.Page = 1
    setPagination({ ...pagination })
  }

  const handleToggleStatus = (val: boolean) => {
    setFilter({
      ...filter,
      selectedOnly: val,
    })
    pagination.Page = 1
    setPagination({ ...pagination })
  }

  const isSelect = (productID: number, optionID: number) => {
    const data = selectProduct.find(
      item => item.product_id === productID && item.product_option_id === optionID,
    )
    return data ? true : false
  }

  const isDisabled = (productID: number, optionID: number) => {
    const data = disableProduct.find(
      item => item.product_id === productID && item.product_option_id === optionID,
    )
    return data ? true : false
  }

  const removeID = (productID: number, optionID: number) => {
    return selectProduct.filter(
      (item: PointProductConfig) => item.product_id !== productID || item.product_option_id !== optionID,
    )
  }

  useEffect(() => {
    const timer1 = setTimeout(() => onFilter('keyword', searchKeyword), 1000)
    return () => {
      clearTimeout(timer1)
    }
  }, [searchKeyword])

  useEffect(() => {
    pagination.Page = 1
    setPagination({ ...pagination })
  }, [filter])

  const onSelectProduct = (product: PointProductConfig) => {
    let newSelect = cloneDeep(selectProduct) || []
    if (isSelect(product.product_id, product.product_option_id)) {
      newSelect = removeID(product.product_id, product.product_option_id)
    } else {
      newSelect.push({ ...product })
    }
    setSelectProduct([...newSelect])
  }

  const onSave = () => {
    onSaveProduct(selectProduct)
  }

  const renderImage = (img: string) => (
    <ThumbImage src={appConfig.assetCdnEndpoint + img} fallback={ImageFallback} />
  )

  const renderActionButton = (id: number, record: PointProductConfig) => {
    return (
      <Space size="small" wrap={true} direction="vertical">
        <Checkbox
          onChange={() => onSelectProduct(record)}
          checked={isSelect(record.product_id, record.product_option_id)}
          disabled={isDisabled(record.product_id, record.product_option_id)}
        />
      </Space>
    )
  }

  const renderProductName = (title: string, record: PointProductConfig) => {
    const isSameTitle =
      title.trim() == (record && record.product_option_title && record?.product_option_title.trim())
    return (
      <>
        <RowTile>{title}</RowTile>
        {!isSameTitle && <ProductDesc>{record.product_option_title}</ProductDesc>}
      </>
    )
  }

  const formatProductOptions = (datas: Data[]) => {
    const data = [] as PointProductConfig[]

    if (filter.selectedOnly) {
      datas &&
        datas.forEach((item: Data) => {
          item.product_options.forEach((options: ProductOptions) => {
            if (isSelect(item.id, options.id)) {
              data.push(formatData(item, options))
            }
          })
        })
    } else {
      datas &&
        datas.forEach((item: Data) => {
          item.product_options.forEach((options: ProductOptions) => {
            data.push(formatData(item, options))
          })
        })
    }

    return data
  }

  const formatData = (item: Data, options: ProductOptions) => {
    return {
      code: item.code,
      title: item.title,
      product_option_title:
        item.product_options && item.product_options.length > 1 ? options.title : item.title,
      product_option_id: options.id,
      product_id: item.id,
      picture: options.photo || item.photos[0],
      price: 0,
      quantity: options.quantity + (options?.quantity_offline || 0),
      current_stock: options.quantity + (options?.quantity_offline || 0),
      unit: item.uom?.name || '',
      // product_photo: options.photo || item.photos[0],
      // amount: options.quantity + (options?.offline_quantity || 0),
      // price_per_unit: options[customerType] || 0,
      // product_uom: item.uom?.name || '',
      brand: item.manufacturer?.name || '',
      bom: item.bom,
    } as PointProductConfig
  }

  const columns = [
    {
      //title: <Checkbox onChange={onSelectAll} checked={isSelectAll()}></Checkbox>,
      title: 'เลือก',
      dataIndex: 'action',
      key: 'action',
      render: renderActionButton,
      width: '80px',
      align: 'center',
    },
    {
      title: 'รูปภาพสินค้า',
      dataIndex: 'picture',
      key: 'picture',
      render: renderImage,
      width: '120px',
    },
    {
      title: 'รหัสสินค้า',
      dataIndex: 'code',
      key: 'code',
    },
    {
      title: 'ชื่อสินค้า',
      dataIndex: 'title',
      key: 'title',
      render: renderProductName,
    },
    {
      title: 'ยี่ห้อ',
      dataIndex: 'brand',
      key: 'brand',
    },
    // {
    //   title: 'คงเหลือ',
    //   dataIndex: 'quantity',
    //   key: 'quantity',
    //   // eslint-disable-next-line react/display-name
    //   render: (quantity: number) => {
    //     return quantity <= 10 ? <StockMin>{numberWithComma(quantity)}</StockMin> : numberWithComma(quantity)
    //   },
    // },
    {
      title: 'หน่วย',
      dataIndex: 'unit',
      key: 'unit',
    },
  ]

  const PaginationContent = (
    <Pagination
      currentPage={pagination.Page}
      totalRows={meta?.totalCount || 0}
      perPage={pagination.RowPerPage}
      onClickPage={(page: number) => {
        pagination.Page = page
        setPagination({ ...pagination })
      }}
      onChangeNumber={(number: number) => {
        pagination.RowPerPage = number
        setPagination({ ...pagination })
      }}
      changePerPage={true}
    />
  )

  const FilterContent = (
    <FilterWrapper>
      <Row justify="start" align="bottom" gutter={[16, 16]}>
        <Col md={8} xs={24}>
          <SearchInput
            placeholder="ค้นหาชื่อ,รหัสสินค้า"
            prefix={<SearchOutlined />}
            allowClear
            value={searchKeyword}
            onChange={(evt: any): void => setSearchKeyword(evt.target.value)}
          />
        </Col>
        <Col md={8} xs={24}>
          <SelectItem
            name={'manufactuers'}
            label={''}
            isRequired={true}
            value={filter.manufactuers}
            menu={getMenuSelect(manufactuers.data)}
            placeHolder={'ยี่ห้อ'}
            onChange={(val: any): void => onFilter('manufactuers', val)}
          />
        </Col>
        <Col md={8} xs={24}>
          <Category
            placeholder="หมวดหมู่สินค้า"
            data={filter.categories}
            categories={categories.data}
            handleChange={(val: []) => onFilter('categories', val)}
          />
        </Col>
        {/* <Col>
          <PrimaryButton text="ค้นหา" btnType="Cancel" onClick={onClickSearch} />
        </Col> */}
      </Row>
    </FilterWrapper>
  )

  const FooterContent = (
    <Space size="middle" align="baseline">
      <PrimaryButton text="ยกเลิก" btnType="Cancel" onClick={onCloseDrawer} />
      <PrimaryButton text={`บันทึก (สินค้าที่เลือก ${selectProduct?.length || 0} รายการ)`} onClick={onSave} />
    </Space>
  )

  return (
    <DetailDrawer
      width={'70%'}
      title={title}
      onCloseDrawer={onCloseDrawer}
      visible={visible}
      footer={FooterContent}
    >
      {FilterContent}
      {selectProduct.length > 0 && (
        <Row justify="start">
          <Col>
            <SwitchStyled>
              <Switch checked={filter.selectedOnly} onChange={handleToggleStatus} size="small" /> &nbsp;
              <LabelItem
                label={`การแสดงรายการสินค้า : ${
                  filter.selectedOnly ? 'แสดงเฉพาะสินค้าที่เลือก' : 'แสดงสินค้าทั้งหมด'
                }`}
              />
            </SwitchStyled>
          </Col>
        </Row>
      )}
      <TableListPage
        rowKey="option_id"
        columns={columns}
        datas={formatProductOptions(datas)}
        isLoading={event.IsLoading}
        paginationContent={PaginationContent}
        scrollX={800}
        size="small"
      />
    </DetailDrawer>
  )
}

const ThumbImage = styled(Image)`
  border-radius: 5px;
  width: 90px;
  height: 90px;
  object-fit: cover;
`

const FilterWrapper = styled.div`
  padding: 0 0 5px 0;
`

const SearchInput = styled(Input)`
  border-radius: 6px;
  height: 45px;
`

const SwitchStyled = styled.div`
  margin: 15px 0;
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body4};
`

const RowTile = styled.div`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body4};
`

const ProductDesc = styled(RowTile)`
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.grey};
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body5};
`

const mapStateToProps = (state: RootState) => {
  return {
    currentUser: selectCurrentUser(state),
    event: selectListEvent(state),
    dataList: selectList(state),
    categories: selectCateList(state),
    manufactuers: selectManufactuerList(state),
    configs: selectDatas(state),
  }
}

type ReduxProps = ReturnType<typeof mapStateToProps>

export default connect(mapStateToProps)(ProductsDrawer)
